export default __webpack_public_path__ + "static/media/satisfaction.12ecd6b4.svg";